import React, { createContext, useContext, useEffect, useState } from "react";
import { LANGS } from "../i18n/translations";

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
    if (stored && LANGS.includes(stored)) return stored;
    const browser = typeof navigator !== "undefined" ? navigator.language?.slice(0, 2) : "de";
    return LANGS.includes(browser) ? browser : "de";
  });

  useEffect(() => {
    try { localStorage.setItem("lang", lang); } catch (e) {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
